export default __webpack_public_path__ + "static/m-blog2-54792644616c50c399d2ebeaa1ab0b49.jpg";